module.exports = __webpack_public_path__ + "static/media/hero-img.b6c8ce19.png";